import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card card-custom bg-transparent mb-5 shadow-none" }
const _hoisted_2 = { class: "card-body pt-2 px-0" }
const _hoisted_3 = { class: "table-responsive" }
const _hoisted_4 = { class: "table table-borderless align-middle" }
const _hoisted_5 = { class: "pl-0 w-55px" }
const _hoisted_6 = { class: "symbol symbol-55px flex-shrink-0 me-4" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "ps-0 flex-column min-w-300px" }
const _hoisted_9 = { class: "text-muted fw-bold" }
const _hoisted_10 = { class: "me-4 me-md-19 text-md-right" }
const _hoisted_11 = {
  href: "#",
  class: "text-gray-800 fw-bolder fs-6 mb-1"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bold" }, "Paid", -1)
const _hoisted_13 = { class: "text-end pe-0" }
const _hoisted_14 = { class: "svg-icon svg-icon-4" }
const _hoisted_15 = { class: "svg-icon svg-icon-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, i) => {
              return (_openBlock(), _createElementBlock("tr", { key: i }, [
                _createElementVNode("th", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["symbol-label", `bg-light-${item.bg}`])
                    }, [
                      _createElementVNode("img", {
                        src: item.svg,
                        class: "h-75 align-self-end",
                        alt: ""
                      }, null, 8, _hoisted_7)
                    ], 2)
                  ])
                ]),
                _createElementVNode("td", _hoisted_8, [
                  _createVNode(_component_router_link, {
                    to: "/account",
                    class: "text-gray-800 fw-bolder text-hover-primary fs-6 mb-1 modal-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("div", _hoisted_9, _toDisplayString("Uses: " + item.uses), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(item.paid), 1),
                    _hoisted_12
                  ])
                ]),
                _createElementVNode("td", _hoisted_13, [
                  _createVNode(_component_router_link, {
                    to: "/account",
                    class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm modal-link"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_14, [
                        _createElementVNode("span", _hoisted_15, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Arrow-right.svg" })
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}